import { useSyncExternalStore } from 'react';
import { consentDecided, onConsentChange } from '../../domain/consent';

/** Re-renders the calling component when the consent decision changes —
 *  same pattern as `useLang`. */
export function useConsent(): boolean {
  return useSyncExternalStore(onConsentChange, consentDecided);
}
